export interface StaffAttendanceRecord {
  id: string;
  staffId: string;
  staffName: string;
  role: string;
  className: string;
  date: string;
  status: 'present' | 'absent' | 'on-leave' | 'half-day';
  checkIn?: string;
  checkOut?: string;
  remark: string;
}

const today = new Date();
const todayStr = today.toISOString().split('T')[0];

function offsetDate(days: number): string {
  const d = new Date(today);
  d.setDate(d.getDate() - days);
  return d.toISOString().split('T')[0];
}

function pickStatus(index: number, dateStr: string): 'present' | 'absent' | 'on-leave' | 'half-day' {
  if (dateStr === todayStr) {
    const todayStatuses: Array<'present' | 'absent' | 'on-leave' | 'half-day'> = [
      'present', 'present', 'present', 'present', 'present', 'present',
      'present', 'present', 'present', 'on-leave', 'half-day', 'present',
      'present', 'on-leave', 'present', 'present', 'absent', 'present',
    ];
    return todayStatuses[index] || 'present';
  }

  const hash = (index * 7 + dateStr.length * 3) % 20;
  if (hash === 0 || hash === 13) return 'absent';
  if (hash === 5) return 'half-day';
  if (hash === 10) return 'on-leave';
  return 'present';
}

function generateCheckIn(status: 'present' | 'absent' | 'on-leave' | 'half-day'): string | undefined {
  if (status === 'absent' || status === 'on-leave') return undefined;
  const hour = 8 + Math.floor(Math.random() * 2);
  const min = Math.floor(Math.random() * 30);
  return `${String(hour).padStart(2, '0')}:${String(min).padStart(2, '0')}`;
}

function generateCheckOut(status: 'present' | 'absent' | 'on-leave' | 'half-day'): string | undefined {
  if (status === 'absent' || status === 'on-leave') return undefined;
  if (status === 'half-day') {
    const hour = 12 + Math.floor(Math.random() * 2);
    const min = Math.floor(Math.random() * 60);
    return `${String(hour).padStart(2, '0')}:${String(min).padStart(2, '0')}`;
  }
  const hour = 16 + Math.floor(Math.random() * 2);
  const min = Math.floor(Math.random() * 60);
  return `${String(hour).padStart(2, '0')}:${String(min).padStart(2, '0')}`;
}

const staffList = [
  { staffId: 'TCH-2024-001', staffName: 'Ms. Emily Watson', role: 'Special Educator', className: 'Pre Primary - A' },
  { staffId: 'TCH-2024-002', staffName: 'Ms. Jennifer Lee', role: 'Speech Therapist', className: 'Pre Primary - B' },
  { staffId: 'TCH-2024-003', staffName: 'Dr. Sarah Mitchell', role: 'Clinical Psychologist', className: 'Primary - A' },
  { staffId: 'TCH-2024-004', staffName: 'Mr. James Okafor', role: 'Special Educator', className: 'Primary - B' },
  { staffId: 'TCH-2024-005', staffName: 'Ms. Emma Reyes', role: 'Occupational Therapist', className: 'Secondary - A' },
  { staffId: 'TCH-2024-006', staffName: 'Mr. David Kumar', role: 'Behaviour Therapist', className: 'Secondary - B' },
  { staffId: 'TCH-2024-007', staffName: 'Ms. Priya Nair', role: 'Art Therapist', className: 'Pre Primary - A' },
  { staffId: 'TCH-2024-008', staffName: 'Mr. Arjun Desai', role: 'Physiotherapist', className: 'Primary - A' },
  { staffId: 'TCH-2024-009', staffName: 'Ms. Fatima Sheikh', role: 'Counsellor', className: 'Secondary - A' },
  { staffId: 'TCH-2024-010', staffName: 'Mr. Ravi Menon', role: 'Music Therapist', className: 'Pre Primary - B' },
  { staffId: 'TCH-2024-011', staffName: 'Ms. Ananya Gupta', role: 'Play Therapist', className: 'Primary - B' },
  { staffId: 'TCH-2024-013', staffName: 'Ms. Kavita Joshi', role: 'Audiologist', className: 'Pre Primary - A' },
  { staffId: 'TCH-2024-014', staffName: 'Mr. Sanjay Patil', role: 'Vision Specialist', className: 'Primary - A' },
  { staffId: 'TCH-2024-015', staffName: 'Ms. Lakshmi Iyer', role: 'Vocational Trainer', className: 'Secondary - B' },
  { staffId: 'TCH-2024-016', staffName: 'Mr. Carlos Menezes', role: 'Assistant Teacher', className: 'Pre Primary - B' },
  { staffId: 'TCH-2024-017', staffName: 'Ms. Neha Kapoor', role: 'Special Educator', className: 'Secondary - A' },
  { staffId: 'TCH-2024-018', staffName: 'Mr. Rohit Verma', role: 'Speech Therapist', className: 'Primary - B' },
];

const daysToGenerate = 30;
const allRecords: StaffAttendanceRecord[] = [];

for (let d = 0; d < daysToGenerate; d++) {
  const dateStr = offsetDate(d);
  for (let i = 0; i < staffList.length; i++) {
    const s = staffList[i];
    const status = pickStatus(i, dateStr);
    allRecords.push({
      id: `staff-att-${d}-${i}`,
      staffId: s.staffId,
      staffName: s.staffName,
      role: s.role,
      className: s.className,
      date: dateStr,
      status,
      checkIn: generateCheckIn(status),
      checkOut: generateCheckOut(status),
      remark: '',
    });
  }
}

export const staffAttendanceRecords: StaffAttendanceRecord[] = allRecords;

export const staffRoles = [
  'Special Educator',
  'Speech Therapist',
  'Clinical Psychologist',
  'Occupational Therapist',
  'Behaviour Therapist',
  'Art Therapist',
  'Music Therapist',
  'Play Therapist',
  'Counsellor',
  'Physiotherapist',
  'Social Worker',
  'Audiologist',
  'Vision Specialist',
  'Vocational Trainer',
  'Assistant Teacher',
];